import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

export function StatusPill({status, direction}) {
  const colors = {
    DELIVERED: {bg: "#c6f6d5", color: "#22543d"},
    SENT: {bg: "#bee3f8", color: "#2a4365"},
    FAILED: {bg: "#fed7d7", color: "#822727"},
    RECEIVED: {bg: "#e9d8fd", color: "#44337a"},
    READ: {bg: "#e2e8f0", color: "#4a5568"},
  };
  const s = colors[status] ?? {bg: "#e2e8f0", color: "#4a5568"};
  return (
    <span style={{
      background: s.bg,
      color: s.color,
      borderRadius: "4px",
      fontSize: "11px",
      fontWeight: 600,
      padding: "2px 7px",
      letterSpacing: "0.04em",
      textTransform: "uppercase",
    }}>
      {status}
    </span>
  );
}

const MESSAGE_TYPE_ICONS = {
  INVOICE_PAID: <PaidOutlinedIcon fontSize="small" />,
  CONTRACT_NEGOTIATION: <DescriptionOutlinedIcon fontSize="small" />,
  MAINTENANCE: <BuildOutlinedIcon fontSize="small" />,
  GENERIC: <ChatBubbleOutlineOutlinedIcon fontSize="small" />,
};

export function getTypeIcon(type) {
  return MESSAGE_TYPE_ICONS[type] || MESSAGE_TYPE_ICONS.GENERIC;
}
export function Badge({count}) {
  if (!count) return null;
  return (
    <span style={{
      background: "#e53e3e",
      color: "#fff",
      borderRadius: "999px",
      fontSize: "11px",
      fontWeight: 700,
      padding: "1px 6px",
      marginLeft: "6px",
      minWidth: "18px",
      display: "inline-block",
      textAlign: "center",
      lineHeight: "18px",
    }}>
      {count > 99 ? "99+" : count}
    </span>
  );
}

export function formatTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  const diff = now - d;
  if (diff < 60000) return "just now";
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`;
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}h ago`;
  if (diff < 7 * 86400000) return `${Math.floor(diff / 86400000)}d ago`;
  return d.toLocaleDateString();
}

export function EmptyState({icon, title, body}) {
  return (
    <div style={{textAlign: "center", padding: "56px 24px", color: "#a0aec0"}}>
      <div style={{fontSize: "40px", marginBottom: "12px"}}>{icon}</div>
      <div style={{fontWeight: 600, color: "#4a5568", marginBottom: "6px"}}>{title}</div>
      {body && <div style={{fontSize: "14px"}}>{body}</div>}
    </div>
  );
}


export function Spinner({size = 20}) {
  return (
    <span style={{
      display: "inline-block",
      width: size,
      height: size,
      border: "2px solid #e2e8f0",
      borderTopColor: "#667eea",
      borderRadius: "50%",
      animation: "spin 0.7s linear infinite",
    }} />
  );
}


export function ErrorBanner({message, onDismiss}) {
  return (
    <div style={{
      background: "#fff5f5",
      border: "1px solid #fc8181",
      borderRadius: "8px",
      padding: "12px 16px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: "14px",
      color: "#822727",
      marginBottom: "12px",
    }}>
      <span><ErrorOutlineOutlinedIcon color="error"/> {message}</span>
      {onDismiss && (
        <button onClick={onDismiss} style={{background: "none", border: "none", cursor: "pointer", color: "#822727", fontWeight: 700}}>✕</button>
      )}
    </div>
  );
}

export const primaryBtn = {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  padding: "9px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  fontWeight: 600,
  fontSize: "14px",
  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  color: "#fff",
};

export const secondaryBtn = {
  padding: "9px 20px",
  borderRadius: "8px",
  border: "1px solid #e2e8f0",
  cursor: "pointer",
  fontWeight: 600,
  fontSize: "14px",
  background: "#fff",
  color: "#4a5568",
};

export const inputStyle = {
  width: "100%",
  padding: "9px 12px",
  borderRadius: "8px",
  border: "1px solid #e2e8f0",
  fontSize: "14px",
  color: "#1a202c",
  background: "#fff",
  outline: "none",
  boxSizing: "border-box",
  transition: "border-color 0.15s",
};


export const containerStyle = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
  background: "#fff",
  borderRadius: "16px",
  overflow: "hidden",
  border: "1px solid #e8e8f0",
  boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
};
